// dont't parse strings in attributes, for example ="..."

export const parseBrandName = (s: string = '') =>
  s
    // #39003 SERVICE in "24h SERVICE" should be italic
    .replace(/24h SERVICE(?![^="]*")/gi, '24h <em>SERVICE</em>')
    .split(' ')
    .map(item => item.replace(/BusStore(?![^="]*")/gi, '<em>BusStore</em>'))
    .join(' ');
